module.exports = __webpack_public_path__ + "img/full-complete.fecac023.svg";